import { render, staticRenderFns } from "./DashboardCardSkeleton.vue?vue&type=template&id=5fb8ecc1&"
import script from "./DashboardCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./DashboardCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports